import endsWith from 'lodash/endsWith';
import { extractRootDomain } from './url';

export function redirectToTargetLandingPage(options = {}, siteUrl) {
  let redirected = false;

  function checkIfTargetedLandingPageIsMallDomain(targetedLandingPage) {
    const siteUrlDomain = extractRootDomain(siteUrl);
    const targetedLandingPageDomain = extractRootDomain(targetedLandingPage);

    return endsWith(targetedLandingPageDomain, siteUrlDomain);
  }

  function clearRelatedData() {
    sessionStorage.removeItem('targetLandingPage');
    sessionStorage.removeItem('shouldRedirectToTargetLandingPage');
    sessionStorage.removeItem('redirectIfURLContains');
  }

  function clearRelatedDataAndRedirect(forceReload) {
    let targetedLandingPage = sessionStorage.getItem('targetLandingPage');

    targetedLandingPage = (targetedLandingPage && checkIfTargetedLandingPageIsMallDomain(targetedLandingPage)) ?
      targetedLandingPage : siteUrl;
    clearRelatedData();
    redirected = true;
    window.location.href = targetedLandingPage;

    // If current href and target landing href are the same BUT have hash values (same or differerent),
    // page is not reloading on window.location.href assign so reloading it manually
    if (forceReload && window.location.href === targetedLandingPage && window.location.hash) {
      window.location.reload();
    }
  }

  const shouldRedirectToTargetedLandingPage = sessionStorage.getItem('shouldRedirectToTargetLandingPage');
  const redirectIfURLContains = sessionStorage.getItem('redirectIfURLContains');

  if (shouldRedirectToTargetedLandingPage) {
    if (window.location.href.substring(redirectIfURLContains) !== 0) {
      clearRelatedDataAndRedirect();
    }
    // no option for this now, just always delete everything even if we didn't redirect
    clearRelatedData();
  } else if (options.force) {
    clearRelatedDataAndRedirect(true);
  }

  return redirected;
}
